import Base from './components/cells/Base';
import Currency from './components/cells/Currency';

export default function CurrencyCell() {}

CurrencyCell.prototype.init = function (params) {
    this.eGui = Base(Currency(params), params);
    return;
};

CurrencyCell.prototype.getGui = function () {
    return this.eGui;
};
